export var array = Array.isArray;
export function primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
//# sourceMappingURL=is.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/snabbdom/es/is.js
// module id = 298
// module chunks = 0